import { indexItems } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">吃瓜目录</h2>
          <p className="text-sm text-foreground-600">分类浏览，找到你最感兴趣的瓜</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 p-5 bg-background-100 rounded-xl hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm text-foreground-900 whitespace-nowrap">{item.name}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600 line-clamp-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}